import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { ListingCard } from "@/components/ListingCard";

export default function Listings() {
  const { t, i18n } = useTranslation();
  const [listings, setListings] = useState([]);

  useEffect(() => {
    api.get("/listings").then(r => setListings(r.data || []));
  }, []);

  return (
    <div data-testid="listings-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
      <p className="overline mb-3">{t("listings.title")}</p>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#2C2A29] tracking-tight">{t("listings.title")}</h1>
      <p className="text-[#595450] mt-3 max-w-xl">{t("listings.sub")}</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
        {listings.map((l) => <ListingCard key={l.listing_id} listing={l} lang={i18n.language} />)}
      </div>
    </div>
  );
}
